export const startsWithNumber = (value: string) =>
  /^\d/.test(value.trimStart());

export const compareAlphabeticallyWithNumbersFirst = (
  firstValue: unknown,
  secondValue: unknown,
) => {
  const first = String(firstValue ?? "").trimStart();
  const second = String(secondValue ?? "").trimStart();

  const firstStartsWithNumber = startsWithNumber(first);
  const secondStartsWithNumber = startsWithNumber(second);

  if (firstStartsWithNumber !== secondStartsWithNumber) {
    return firstStartsWithNumber ? -1 : 1;
  }

  return first.localeCompare(second, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

export const compareSelectOptionsAlphabeticallyWithNumbersFirst = <
  T extends { label?: string },
>(
  firstOption: T,
  secondOption: T,
) =>
  compareAlphabeticallyWithNumbersFirst(firstOption.label, secondOption.label);
